import React, { useRef, useEffect, useContext, useState } from 'react';
import { useTheme } from '@mui/styles';
import PropTypes from 'prop-types';
import D3donut from '../../d3/D3Donut';

import { GroupsContext } from '../../data/groups-service';

import {
    scaleOrdinal as D3scaleOrdinal,
    select as D3select,
} from 'd3';

const DonutChart = ({
    mouseover,
    data,
    filter,
    size,
    onclick,
    className,
    isBT,
}) => {
    const d3Container = useRef(null);
    const theme = useTheme();
    const { groupKeys } = useContext(GroupsContext);
    const [groupFilter, setGroupFilter] = useState();

    useEffect((didUpdate) => {
        // put purple at the top of the colors list
        let themeColors = theme.ChartColors;
        if (isBT) {
            themeColors = [theme.palette.backtesting.main].concat(themeColors);
        }
        const chartColors = theme.SeverityColors.concat(themeColors);
        const colors = D3scaleOrdinal().range(chartColors).domain(groupKeys);

        const handleOnMouseover = g => {
            setGroupFilter(g);
            mouseover && mouseover(g);
        };

        if (d3Container.current) {
            const node = d3Container.current;
            const g = D3select(node)
                .data([data])
                .join('g')
                .call(D3donut()
                    .theme(theme)
                    .colors(colors)
                    .date(filter)
                    .size(size)
                    .group(groupFilter)
                    .on('mouseover', handleOnMouseover)
                    .on('click', onclick));
            g.exit().remove();
        }
    }, [theme, mouseover, onclick, size, data, filter, groupKeys, groupFilter, isBT]);

    return (
        <div
            className={className}
            name="donut_chart"
            ref={d3Container}
            style={ { width: size, height: size }}>
        </div>
    );
};

DonutChart.propTypes = {
    size: PropTypes.number.isRequired,
    shift: PropTypes.number,
    data: PropTypes.array.isRequired,
    filter: PropTypes.object,
    className: PropTypes.string,
    mouseover: PropTypes.func,
    onclick: PropTypes.func,
    isBT: PropTypes.bool,
};

export default DonutChart;
